import { render, staticRenderFns } from "./SenditTable.vue?vue&type=template&id=2f492679&"
import script from "./SenditTable.vue?vue&type=script&lang=js&"
export * from "./SenditTable.vue?vue&type=script&lang=js&"
import style0 from "./SenditTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports